import { currentTierIIReportingYear } from "encamp-shared/src/constants/tierii";

export function buildWasteFacilityUrl(tenantId: string, facilityId: string): string {
  const year = currentTierIIReportingYear;
  return `/o/${tenantId}/waste/facilities/${facilityId}?startDate=${year}-01-01&endDate=${year}-12-31&view=REPORTABLE`;
}

/** Tenant waste streams grid with `wasteStreamId` selected, opening its detail drawer. */
export function buildWasteStreamUrl(tenantId: string, wasteStreamId: string): string {
  return `/o/${tenantId}/waste/streams/${wasteStreamId}`;
}

/** Tenant waste streams grid with `registrationId` selected, opening its registration drawer. */
export function buildStateRegistrationUrl(tenantId: string, registrationId: string): string {
  return `/o/${tenantId}/waste/streams/registration/${registrationId}`;
}
